import { CbSpinnerModule } from '@chubb/ui-components/cb-spinner';
import { CbSearchInputModule } from '@chubb/ui-components/cb-search-input';
import { CbInputModule } from '@chubb/ui-components/cb-input';
import { CbSelectChoiceModule } from '@chubb/ui-components/cb-select-choice';
import { NgModule } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { EmpTileComponent } from './emp-tile.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { NgxMaskDirective } from 'ngx-mask';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { AppAnalyticsModule } from '../../../../directives/app-analytics.module';
@NgModule({
    declarations: [EmpTileComponent],
    imports: [
        CommonModule,
        CbSpinnerModule,
        ProgressSpinnerModule,
        CbSearchInputModule,
        AutoCompleteModule,
        AppAnalyticsModule,
        CbInputModule,
        NgxMaskDirective,
        CbSelectChoiceModule,
        SelectModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        ReactiveFormsModule,
    ],
    exports: [EmpTileComponent],
})
export class EmpTileModule {}
